import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { LandingPageExecutionJobs } from "./landingPageExecutionJobs";

export default function ExecutionMainPage() {
  useEffect(() => {
    document.title = "PHIL App - Execution Jobs";
  }, []);

  return (
    <div className="app_content">
      <Container fluid>
        <h2 className="mb-0">Execution Jobs Inside My Activities</h2>
        <LandingPageExecutionJobs myExecutionJobs={false} />
      </Container>
    </div>
  );
}
